export const counselor = {
  keyAspects: 'Zentrale Aspekte',
  KEYASPECTS: 'Zentrale Aspekte',
  keyAspectsText:
    'Hier finden Sie die wichtigsten Informationen und Tipps zur Planung und Vorbereitung Ihrer Sanierungs-, Renovierungs-, und Umbauprojekte. Wahres Insider-Wissen, damit Sie Ihr Projekt vom ersten Schritt an erfolgreich umsetzen können.',
  renovationTips: 'Sanierungstipps',
  RENOVATIONTIPS: 'Sanierungstipps',
  finance: 'Finanzen',
  FINANCE: 'Finanzen',
  energeticRenovation: 'Energetisch Sanieren',
  ENERGETICRENOVATION: 'Energetisch Sanieren',
  others: 'Weiteres',
  OTHERS: 'Weiteres',
  counselor: 'HAUSHELD RATGEBER',
  counselorText:
    'Auf unseren Ratgeberseiten finden Sie detaillierte Informationen zu diversen Renovations- und Umbauprojekten. Sie helfen Ihnen dabei, sich optimal über die Möglichkeiten Ihres Projekts zu erkundigen. Worauf warten Sie noch? Gehen Sie auf Entdeckungstour!',
  allArticles: 'Alle Artikel',
  allArticlesTitel: 'Alle Artikel',
  findCounselor: 'Ratgeber finden',
  newestCounselor: 'Neueste Ratgeber',
  popularGuides: 'Beliebte Ratgeber',
  mortageExtension: 'Hypothekverlängerung',
  limeProtection: 'Kalkschutz',
  kitchenDesign: 'Küchendesign',
  renovationFinance: 'Renovation und Finanzierung',
  tipsForPellet: 'Tipps für Ihre Pelletheizung',
  topic: 'Thema',
  readingDuration: 'Lesezeit: ',
  placeholder: '5min',
  alwaysStayUpToDate: 'Stets auf dem Laufenden bleiben!',
  upToDateText:
    'Die neuesten Technologien und Produkte, Tipps & Tricks zur Planung und Umsetzung von Sanierungsarbeiten und Neubauten, oder auch spannende Hinweise zu Finanzen und Steuern – Mit unserem Newsletter erhalten Sie Informationen zu den wichtigsten Themen rund ums Haus.',
  subscribeNewsletter: 'Newsletter abonnieren',
  subscribeNewsletterSuccessMessage: 'Sie wurden erfolgreich für den Newsletter angemeldet.',
  financeText: '',
  renovationTipsText: '',
  energeticRenovationText: '',
  allArticlesText: '',
  othersText: '',
  HausHeldCounselor: 'HausHeld Ratgeber > ',
  getQuoteNow: 'Jetzt Offerten einholen',
  getQuote: 'Offerten einholen',
  renovationTipsTitle: 'Sanierungs-Tipps',
  counselorCategory: 'Ratgeberthemen',
  articleCTABoxText2: 'völlig unverbindlich und ohne versteckte Kosten!',
  sponsoredBy: 'Bereitgestellt von:',
  shareOn: 'Teilen auf: ',
  ownCounselorTitle: 'Eigenen Ratgeber aufschalten?',
  ownCounselorText:
    'Platzieren Sie Ihr spannendes Thema und profitieren Sie von gezieltem Marketing.',
  moreInformation: 'Mehr Informationen',
  backToTop: 'Back to Top',
}
